Monitoring.Views ||= {}

class Monitoring.Views.MovistarAncestorsConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_ancestors_condition_edit"]

  events:
    'click #add-ancestor-id': 'onClickAddAncestorId'
    'click .delete-ancestor-id': 'onClickDeleteAncestorId'
    'keyup #ancestor-id': 'onKeyUp'

  initialize: (@options = {}) ->
    @parentPostIds = @options.parentPostIds
    @parentTweetIds = @options.parentTweetIds
    @parentMediaIds = @options.parentMediaIds
    @currentSelection = 'facebook'

  getParentPostIds: ->
    @parentPostIds

  getParentTweetIds: ->
    @parentTweetIds

  getParentMediaIds: ->
    @parentMediaIds

  render : ->
    @$el.html(@template(@))
    @

  postIdToUrl: (postId) ->
    "https://www.facebook.com/#{postId}/"

  tweetIdToUrl: (tweetId) ->
    "https://twitter.com/statuses/#{tweetId}/"

  mediaIdToUrl: (mediaId) ->
    "https://instagram.com/p/se_puede_calcular/"

  onClickAddAncestorId: (evt) =>
    newIds = _.map(@$el.find('#ancestor-id').val().split(','), (id) -> id.trim())
    @parentPostIds = _.union(@parentPostIds, newIds)
    @currentSelection = 'facebook'
    @render()

  onClickDeleteAncestorId: (evt) =>
    id = $(evt.currentTarget).data('id')
    id = id.toString()
    type = $(evt.currentTarget).data('type')
    if type == 'facebook'
      @parentPostIds = _.without(@parentPostIds, id)
    else if type == 'twitter'
      @parentTweetIds = _.without(@parentTweetIds, id)
    else if type == 'instagram'
      @parentMediaIds = _.without(@parentMediaIds, id)
    else
      throw new Error('Invalid type')
    @render()

  onKeyUp: (evt) =>
    if evt.keyCode == 13 # ENTER
      @$el.find('#add-ancestor-id').click()

  facebookIsChecked: ->
    @$el.find('#ancestors-facebook').prop('checked')

  twitterIsChecked: ->
    @$el.find('#ancestors-twitter').prop('checked')

  instagramIsChecked: ->
    @$el.find('#ancestors-instagram').prop('checked')
